import { propertyCategoryService } from '@/services/api/propertyCategory.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyCategoryModel } from '@/models/api/propertyCategory.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_CATEGORY_MODULE = "api/propertyCategory";

// ACTIONS
export const GET_ALL_PROPERTY_CATEGORY = 'getAllPropertyCategory';
export const CREATE_PROPERTY_CATEGORY = 'createPropertyCategory';
export const GET_PROPERTY_CATEGORY = 'getPropertyCategory';
export const UPDATE_PROPERTY_CATEGORY = 'updatePropertyCategory';
export const UPDATE_PROPERTY_CATEGORY_STATUS = 'updatePropertyCategoryStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_CATEGORY_SUCCESS = "allPropertyCategorySuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_CATEGORY_SUCCESS = "getPropertyCategorySuccess";

export const actions = {
    [GET_ALL_PROPERTY_CATEGORY]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyCategoryService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_CATEGORY_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_CATEGORY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyCategoryService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_CATEGORY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_CATEGORY]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyCategoryService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_CATEGORY_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_CATEGORY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyCategoryService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_CATEGORY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_CATEGORY_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyCategoryService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_CATEGORY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_CATEGORY_SUCCESS](state, {data}) {
        let propertyCategoryList = data.data || [];
        state.list.data = propertyCategoryList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyCategoryList.map(item => propertyCategoryModel(item));
        }
    },
    [GET_PROPERTY_CATEGORY_SUCCESS](state, data) {
        state.details = propertyCategoryModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
